import React, { useEffect, useState } from 'react';

import { CaretUp, List } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import logo from 'src/assets/4i-logo.svg';
import { Button } from 'src/components/Button';
import { MobileMenu } from 'src/components/MobileMenu';
import { RootState } from 'src/redux/store';
import light from 'src/styles/themes/light';
import { TrackGoogleAnalyticsEvent } from 'src/utils/google-analytics';
import { scrollTo } from 'src/utils/scrollTo';

import { ActionContent, Container, MenuContent, Tab } from './styles';
import { Submenu } from './Submenu';
import { casesMenu, resourceMenu } from '../../MenuItems';
// import { LanguageMenu } from '../../LanguageMenu';

export function Header() {
  const [openMenu, setOpenMenu] = useState(false);

  const [openCases, setOpenCases] = useState(false);
  const [openResources, setOpenResources] = useState(false);

  const { urlPrefix } = useSelector((state: RootState) => state.config);
  const { t: translate } = useTranslation();

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const header = document.getElementById('header');

    function setHeaderBackground() {
      const scrollTop =
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        window.scrollY;

      if (header) {
        header.style.background =
          scrollTop === 0 ? 'transparent' : light.colors.white;
      }
    }

    if (
      location.pathname === '/' ||
      location.pathname === '/en/' ||
      location.pathname === '/en'
    ) {
      window.addEventListener('scroll', setHeaderBackground);
    } else if (header) {
      header.style.background = light.colors.white;
    }

    return () => {
      window.removeEventListener('scroll', setHeaderBackground);
    };
  }, [location]);

  return (
    <Container id="header" data-cy="header" data-testid="header">
      <MenuContent>
        <button
          type="button"
          onClick={() => {
            TrackGoogleAnalyticsEvent(
              'Header - Logo da 4intelligence',
              'Ir para a página inicial',
              location.pathname,
            );

            scrollTo(true, 0, 100);
            navigate('/');
          }}
          data-cy="logo-button"
          data-testid="logo-button"
          aria-label={translate('header4iButtonLabel') ?? ''}
        >
          <img src={logo} alt="4intelligence logo" />
        </button>

        <nav className="header-nav">
          {/* <Tab
          data-tooltip-html={translate('soon') ?? ''}
          data-tooltip-id="header-soon-tooltip"
        >
          {translate('product')}
        </Tab>
        <Tab
          data-tooltip-html={translate('soon') ?? ''}
          data-tooltip-id="header-soon-tooltip"
        >
          {translate('section')}
        </Tab> */}
          <Tab
            onClick={() => {
              TrackGoogleAnalyticsEvent(
                'Header - Planos',
                'Ir para a tela de planos',
                location.pathname,
              );
              navigate('/plans');
            }}
            data-testid="plans-button"
          >
            <div>{translate('plans')}</div>
          </Tab>

          <Tab
            onMouseEnter={() => setOpenCases(true)}
            onMouseLeave={() => setOpenCases(false)}
            onClick={() => setOpenCases(!openCases)}
          >
            <div>
              {translate('cases')}
              <CaretUp className={openCases ? 'show-menu' : 'hidden-menu'} />
            </div>

            <Submenu
              title="Entenda mais sobre os casos de uso da nossa plataforma"
              subtitle="Cases"
              menu={casesMenu}
              visible={openCases}
              triangleLeftPosition="1.5rem"
              style={{ marginLeft: '-8rem' }}
            />
          </Tab>

          <Tab
            onMouseEnter={() => setOpenResources(true)}
            onMouseLeave={() => setOpenResources(false)}
            onClick={() => setOpenResources(!openResources)}
          >
            <div>
              {translate('resource')}
              <CaretUp
                className={openResources ? 'show-menu' : 'hidden-menu'}
              />
            </div>

            <Submenu
              menu={resourceMenu}
              visible={openResources}
              style={{ marginLeft: '-2rem' }}
            />
          </Tab>
        </nav>
      </MenuContent>

      <ActionContent>
        {/* <LanguageMenu /> */}

        <Link
          to="https://app.4intelligence.ai/"
          target="_blank"
          rel="noreferrer"
          className="login-button"
          data-cy="login-button"
          data-testid="login-button"
          onClick={() => {
            TrackGoogleAnalyticsEvent(
              'Acessar plataforma',
              'Acessar plataforma',
              location.pathname,
            );
          }}
        >
          {translate('accessButton')}
        </Link>

        <Link
          to={`${urlPrefix}/contact-sales`}
          className="contact-button"
          data-cy="contact-button"
          data-testid="contact-button"
          onClick={() => {
            TrackGoogleAnalyticsEvent(
              'Falar com vendas',
              'Ir para tela Falar com Vendas',
              location.pathname,
            );
          }}
        >
          {translate('contactButton')}
        </Link>

        <Link
          to={`${urlPrefix}/freemium/sign-up`}
          className="start-free-button"
          data-cy="start-free-button"
          data-testid="start-free-button"
          onClick={() => {
            TrackGoogleAnalyticsEvent(
              'Comece grátis',
              'Ir para cadastro do freemium',
              location.pathname,
            );
          }}
        >
          {translate('startFreeButton')}
        </Link>

        <Button
          buttonType="secondary"
          icon={<List />}
          onClick={() => {
            TrackGoogleAnalyticsEvent(
              'Menu mobile',
              'Abrir menu mobile',
              location.pathname,
            );
            setOpenMenu(true);
          }}
          className="menu-button"
          data-cy="menu-button"
          data-testid="menu-button"
          aria-label={translate('headerMenuButtonLabel') ?? ''}
        />
      </ActionContent>

      <MobileMenu openMenu={openMenu} setOpenMenu={setOpenMenu} />
    </Container>
  );
}
